/**
 * MCP Bootstrap constants (FE).
 * Centralizes all MCP Bootstrap related constants.
 */

export const MCP_BOOTSTRAP_ACTION_TYPE = {
    GET_STATUS: 'GET_STATUS',
    GENERATE: 'GENERATE'
};

export const MCP_BOOTSTRAP_ERROR_CODE = {
    // Connection errors → connection error popup
    TUNNEL_CREATION_FAILED: 'TUNNEL_CREATION_FAILED',
    SERVICE_ACCOUNT_CREATION_FAILED: 'SERVICE_ACCOUNT_CREATION_FAILED',
    CREDENTIAL_ENCRYPT_FAILED: 'CREDENTIAL_ENCRYPT_FAILED',
    CREDENTIAL_DECRYPT_FAILED: 'CREDENTIAL_DECRYPT_FAILED',
    // ZIP/artifact errors → download error popup
    TEMPLATE_DOWNLOAD_FAILED: 'TEMPLATE_DOWNLOAD_FAILED',
    TEMPLATE_INVALID: 'TEMPLATE_INVALID',
    ZIP_GENERATION_FAILED: 'ZIP_GENERATION_FAILED',
    ARTIFACT_UPLOAD_FAILED: 'ARTIFACT_UPLOAD_FAILED',
    // Precondition changed → COMMSG030 reload popup
    PRECONDITION_CHANGED: 'PRECONDITION_CHANGED',
    PRECONDITION_USER_NOT_FOUND: 'MCP_BOOTSTRAP_USER_NOT_FOUND',
    PRECONDITION_CORPORATION_NOT_FOUND: 'MCP_BOOTSTRAP_CORPORATION_NOT_FOUND',
    PRECONDITION_FEATURE_DISABLED: 'MCP_BOOTSTRAP_FEATURE_DISABLED',
    PRECONDITION_INELIGIBLE: 'MCP_BOOTSTRAP_INELIGIBLE',
    PRECONDITION_USER_IS_NOT_PROJECT_MANAGER: 'MCP_BOOTSTRAP_USER_IS_NOT_PROJECT_MANAGER'
};

export const ZIP_ERROR_CODES = [
    'TEMPLATE_DOWNLOAD_FAILED',
    'TEMPLATE_INVALID',
    'ZIP_GENERATION_FAILED',
    'ARTIFACT_UPLOAD_FAILED'
];

export const PRECONDITION_ERROR_CODES = [
    'PRECONDITION_CHANGED',
    'MCP_BOOTSTRAP_USER_NOT_FOUND',
    'MCP_BOOTSTRAP_CORPORATION_NOT_FOUND',
    'MCP_BOOTSTRAP_FEATURE_DISABLED',
    'MCP_BOOTSTRAP_INELIGIBLE',
    'MCP_BOOTSTRAP_USER_IS_NOT_PROJECT_MANAGER'
];


